import UtilityService from '../services/utility.service';

export class CommonService {
    populateDataRows(data, rowTemplate, componentName, componentTemplate) {
        var row = "";
        data.forEach(function(item,index){
          var tpl = rowTemplate;
          tpl = tpl.replace("{MonthYear}", item.MonthYear);
          tpl = tpl.replace("{Count}", item.Count);
          if (item.Month) {
            tpl = tpl.replace("{Month}", item.Month);
          }
          if (item.Year) {
            tpl = tpl.replace("{Year}", item.Year);
          }
          row += tpl;
        });
        _svc.util.html("#" + componentName, componentTemplate);
        _svc.util.html("#data_row", row);
    }

    renderResults(section, component) {
        _cmp.main.hideAll();
        _svc.util.show("#" + component.componentName);
        _svc.util.showLoader("#" + component.componentName);
        if (component.cacheExpired()) {
          _svc.data.getSection(section, component.postBackSuccess, component.postBackFailed);
        } else {
          _svc.util.html("#" + component.componentName, component.cache);
        }
    }
    handleCache(component) {
        component.cache = _svc.util.element(component.componentName).innerHTML;
        component.cacheExpiration = _svc.util.now() + 60;
    }
        

}

setTimeout(function(){
    _svc.common = new CommonService();
}, 1);